import CompanyBlogPreview from './CompanyBlogPreviewContainer';

export default CompanyBlogPreview;
